import { Box, Divider, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

import { DatabaseIntegration } from "features/Group";
import Footer from "components/layout/Footer";
import PageTitle from "components/layout/PageTitle";
import { fillParent, scrollingBox, footerFlex } from "utils/base-styles";

export default function Preferences() {
  return (
    <Box
      sx={{
        ...fillParent,
        ...scrollingBox,
        ...footerFlex,
      }}
    >
      <Helmet>
        <title>Sooth - Group Management - Integrations</title>
      </Helmet>
      <Stack direction="column" pb="50px">
        <PageTitle>Integrations</PageTitle>
        <Typography>
          Connect external research databases so you can search them
          directly from Sooth.
        </Typography>
        <Divider />
        <DatabaseIntegration />
      </Stack>
      <Footer sx={{ px: 0 }} />
    </Box>
  );
}
